/**
 * BẬC LƯƠNG/GIỜ — nguồn duy nhất phía admin (#154220, lệnh sếp 29/08/2026).
 *
 * Sếp: *"Điều chỉnh mức lương tăng dần 20 22 24 25 chứ không phải tăng từng 1000 như hiện tại nữa"*.
 * Phải khớp đúng `on-coffee-server/src/shared/constants/hourly-rate-tiers.ts` — sửa một bên thì
 * sửa cả bên kia, đừng để lệch (server vẫn là nơi chốt hợp lệ, giao diện chỉ chặn trước cho gọn).
 */
export const HOURLY_RATE_TIERS = [20000, 22000, 24000, 25000];

export const isHourlyRateTier = (value) =>
  HOURLY_RATE_TIERS.includes(Number(value));

/** Nhãn hiển thị của một bậc, vd 22000 → "22.000đ/h". */
export const formatHourlyRateTier = (value) =>
  `${Number(value).toLocaleString('vi-VN')}đ/h`;
